import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
import { Label } from './label.js';
const FormFieldRoot = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex flex-col gap-1.5', className), ...props })));
FormFieldRoot.displayName = 'FormField';
// Alias, not a re-implementation — FormField.Label is just Label used inside a
// FormField, so peer-disabled styling and the `required` asterisk come free.
const FormFieldLabel = Label;
const FormFieldControl = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex flex-col', className), ...props })));
FormFieldControl.displayName = 'FormField.Control';
const FormFieldDescription = React.forwardRef(({ className, ...props }, ref) => (_jsx("p", { ref: ref, className: cn('text-xs text-[var(--color-text-muted)]', className), ...props })));
FormFieldDescription.displayName = 'FormField.Description';
const FormFieldError = React.forwardRef(({ className, ...props }, ref) => (_jsx("p", { ref: ref, role: "alert", className: cn('text-xs text-[var(--color-state-danger-fg)]', className), ...props })));
FormFieldError.displayName = 'FormField.Error';
export const FormField = Object.assign(FormFieldRoot, {
    Label: FormFieldLabel,
    Control: FormFieldControl,
    Description: FormFieldDescription,
    Error: FormFieldError,
});
//# sourceMappingURL=form-field.js.map